import React, { useState } from "react"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import { withTranslation } from "react-i18next"
import withRouter from "components/Common/withRouter"
import PropTypes from "prop-types"

/**
 * User account menu rendered in the top navigation bar.
 *
 * Displays links to the user's profile, settings and logout.
 * The username / email is read from the Redux auth state.
 */
const UserMenu = ({ t }) => {
  const [isOpen, setIsOpen] = useState(false)

  const { authUser, accountType } = useSelector(state => state.Login || {})
  const displayName =
    authUser?.name ||
    authUser?.firstName ||
    authUser?.email ||
    t("My Account")

  const toggle = () => setIsOpen(prev => !prev)

  return (
    <Dropdown isOpen={isOpen} toggle={toggle} className="d-inline-block">
      <DropdownToggle
        tag="button"
        className="btn header-item d-flex align-items-center"
        id="page-header-user-dropdown"
        title={t("Account")}
      >
        <i className="bx bx-user-circle" style={{ fontSize: 24 }}></i>
        <span className="d-none d-xl-inline-block ms-2 me-1 fs-6">
          {displayName}
        </span>
        {accountType && (
          <span className="badge bg-primary d-none d-xl-inline-block me-1 fs-8">
            {accountType}
          </span>
        )}
        <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end header_dropdown">
        <DropdownItem>
          <Link to="/profile">
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {t("My Profile")}
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to="/change-password">
            <i className="bx bx-key font-size-16 align-middle me-1" />
            {t("Change Password")}
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to="/my-preference">
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {t("My Preferences")}
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link to="/my-preference?tab=THEME_LOGO">
            <i className="bx bx-palette font-size-16 align-middle me-1" />
            {t("Theme & Logo")}
          </Link>
        </DropdownItem>

        <DropdownItem>
          <Link to="/export-requests">
            <i className="bx bx-export font-size-16 align-middle me-1" />
            {t("Export Requests")}
          </Link>
        </DropdownItem>

        <div className="dropdown-divider" />

        <Link to="/logout" className="dropdown-item">
          <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
          <span>{t("Logout")}</span>
        </Link>
      </DropdownMenu>
    </Dropdown>
  )
}

UserMenu.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withRouter(withTranslation()(UserMenu))
